import styled from 'styled-components';
import { typography } from 'dab-component-lib';
import { basic, MediaStyle } from '../../utils/style-utils';

export const CookiesStyle = styled.div`
  ${typography.Caption1};
  color: ${basic.greyMedium};
  padding: 15px 0;
  ${ MediaStyle.md`
    padding: 30px 0;
  ` }
  a {
    color: ${basic.secondary};
  }
`;


// WEBPACK FOOTER //
// ./src/components/cookies/style.js